import { Component, OnInit, Input } from "@angular/core";
import { ModalController, NavController } from "@ionic/angular";
import { ApiService } from "src/app/services/api.service";
import { NavigationService } from "src/app/services/navigation.service";
import { UtilserviceService } from "src/app/services/utilservice.service";

@Component({
  selector: "app-cancel-booking",
  templateUrl: "./cancel-booking.page.html",
  styleUrls: ["./cancel-booking.page.scss"],
})
export class CancelBookingPage implements OnInit {
  constructor(
    private modal: ModalController,
    private navCtrl: NavController,
    private api: ApiService,
    private util: UtilserviceService,
    private nav: NavigationService
  ) {}
  @Input() booking_id: any;
  ngOnInit() {
    //console.log();
  }
  close() {
    this.api
      .getDataWithToken("appointment/cancel/" + this.booking_id)
      .subscribe((success: any) => {
        if (success.success) {
          const lan = localStorage.getItem("lan");

          if (lan == "en") {
            this.util.presentToast("Booking canceled");
          } else if (lan == "ar") {
            this.util.presentToast("تم إلغاء الحجز");
          } else {
            this.util.presentToast("Rezervare anulată");
          }
          this.nav.appointment();
          this.modal.dismiss(this.booking_id);
          
        }
      });
  }

  closeModel() {
    this.modal.dismiss();
  }
}
